export const APP_MAP_PARAM_OBJECT = 'object'
export const APP_MAP_PARAM_OPERATOR = 'operator'
export const APP_MAP_PARAM_FUNCTION = 'function'

export const moduleMappableParamMenuTabs = Object.freeze({
    [APP_MAP_PARAM_OBJECT]: {
        key: APP_MAP_PARAM_OBJECT,
        label: 'Workflow objects',
        icon: 'fal fa-cubes'
    },
    [APP_MAP_PARAM_OPERATOR]: {
        key: APP_MAP_PARAM_OPERATOR,
        label: 'Operators',
        icon: 'fal fa-calculator-alt'
    },
    [APP_MAP_PARAM_FUNCTION]: {
        key: APP_MAP_PARAM_FUNCTION,
        label: 'Functions',
        icon: 'fal fa-function'
    }
})

export const moduleMappableParamMenuTabsList = Object.freeze(Object.values(moduleMappableParamMenuTabs))
